import { c as _c } from "react/compiler-runtime";
import type React from "react";
interface PaginationProps {
  current: number;
  total: number;
  setPage: React.Dispatch<React.SetStateAction<number>>;
}
const Pagination: React.FC<PaginationProps> = props => {
  const $ = _c(9);
  let t0;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = <li><button type="button" className="ml-0 rounded-l-lg border border-gray-300 bg-white px-3 py-2 text-gray-500 leading-tight hover:bg-gray-100 hover:text-gray-700">Previous</button></li>;
    $[0] = t0;
  } else {
    t0 = $[0];
  }
  let t1;
  if ($[1] !== props.total) {
    t1 = Array.from({
      length: props.total
    }, _temp);
    $[1] = props.total;
    $[2] = t1;
  } else {
    t1 = $[2];
  }
  let t2;
  if ($[3] !== props || $[4] !== t1) {
    t2 = t1.map(pageNum => <li key={`page-${pageNum}`}><button type="button" className={pageNum === props.current ? "border border-gray-300 bg-blue-50 px-3 py-2 text-blue-600 hover:bg-blue-100 hover:text-blue-700" : "border border-gray-300 bg-white px-3 py-2 text-gray-500 leading-tight hover:bg-gray-100 hover:text-gray-700"} onClick={() => {
        props.setPage(pageNum);
      }}>{pageNum + 1}</button></li>);
    $[3] = props;
    $[4] = t1;
    $[5] = t2;
  } else {
    t2 = $[5];
  }
  let t3;
  if ($[6] === Symbol.for("react.memo_cache_sentinel")) {
    t3 = <li><button type="button" className="rounded-r-lg border border-gray-300 bg-white px-3 py-2 text-gray-500 leading-tight hover:bg-gray-100 hover:text-gray-700">Next</button></li>;
    $[6] = t3;
  } else {
    t3 = $[6];
  }
  let t4;
  if ($[7] !== t2) {
    t4 = <div className="my-4 flex flex-row justify-center"><nav aria-label="Page navigation example"><ul className="inline-flex -space-x-px">{t0}{t2}{t3}</ul></nav></div>;
    $[7] = t2;
    $[8] = t4;
  } else {
    t4 = $[8];
  }
  return t4;
};
export default Pagination;
function _temp(_, idx) {
  return idx;
}